import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { ThemeProvider } from "@/theme/ThemeContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import CoachingSalle from "@/pages/CoachingSalle";
import CoachingDomicile from "@/pages/CoachingDomicile";
import CoachingLigne from "@/pages/CoachingLigne";
import APropos from "@/pages/APropos";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import Stats from "@/pages/Stats";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <LanguageProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/coaching-en-salle" element={<CoachingSalle />} />
              <Route path="/coaching-a-domicile" element={<CoachingDomicile />} />
              <Route path="/coaching-en-ligne" element={<CoachingLigne />} />
              <Route path="/a-propos" element={<APropos />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/stats" element={<Stats />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        </LanguageProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
